<template>
  <div id="exploration">
    <InnerContent>
      <div class="content-header">
        <!-- 
        <router-link
          :to="{ name: 'home' }"
          @click.native="
            $gtag.event('click', {
              event_category: 'back_to_start',
              event_label: 'back',
            })
          "
          class="back-link"
        >
          <button class="back">
            <img src="/img/arrow-back-icon-black.svg" alt />
            Back to start
          </button>
        </router-link>
         -->
      </div>
      <div class="content">
        <div class="content-left">
          <div class="content-copy">
            <h1 class="app-title">Early MS Symptoms</h1>
            <div class="intro-desktop">
              <p class="intro-copy">
                Explore the activity and potential effects of early inflammation
                in multiple sclerosis (MS).
              </p>
            </div>
            <router-link :to="{ name: 'inflammation' }">
              <button class="modal-button">
                View Early Inflammation Activity
                <img :src="imageAssetPath + 'img/icon-play.svg'" alt />
              </button>
            </router-link>

            <button
              v-show="selectedInfo === '' || selectedInfo === part.id"
              v-for="part of bodyparts"
              :key="part.id"
              @click="toggleInfo(part.id)"
              :class="[`${part.id}`]"
              class="explore-button"
            >
              <img
                :src="imageAssetPath + 'img/icon-' + part.id + '.svg'"
                class="explore-icon"
                :alt="part.alt"
              />
              <span class="explore-label">{{ part.label }}</span>
              <img
                v-show="selectedInfo === ''"
                :src="[
                  part.id === 'eia'
                    ? imageAssetPath + 'img/icon-plus-black.svg'
                    : imageAssetPath + 'img/icon-plus.svg',
                ]"
                class="explore-plus-minus"
                alt=""
              />
              <img
                v-show="selectedInfo === part.id"
                :src="[
                  part.id === 'eia'
                    ? imageAssetPath + 'img/icon-minus-black.svg'
                    : imageAssetPath + 'img/icon-minus.svg',
                ]"
                class="explore-plus-minus"
                alt="Go back"
              />
            </button>

            <button
              v-show="selectedInfo === ''"
              @click="toggleButton('neuropsychological')"
              class="explore-button"
            >
              <img
                :src="imageAssetPath + 'img/icon-neuro.svg'"
                class="explore-icon"
                alt=""
              />
              <span class="explore-label">Neuropsychological</span>
              <img
                :src="imageAssetPath + 'img/L-Arrow-Down.svg'"
                class="explore-plus-minus"
                alt=""
              />
            </button>
            <div v-show="expandedItem === 'neuropsychological'">
              <button
                v-show="selectedInfo === '' || selectedInfo === part.id"
                v-for="part of neuropsychological"
                :key="part.id"
                @click="toggleInfo(part.id)"
                :class="[`${part.id}`]"
                class="explore-button-other"
              >
                <div class="explore-subheading" v-show="selectedInfo === ''">
                  {{ part.label }}
                  <img
                    v-show="selectedInfo === ''"
                    :src="[
                      part.id === 'eia'
                        ? imageAssetPath + 'img/icon-plus-black.svg'
                        : imageAssetPath + 'img/L-Boxed-Plus-Button.svg',
                    ]"
                    class="explore-plus-button"
                    :alt="part.alt"
                  />
                </div>

                <div
                  class="expand-subheading"
                  v-show="selectedInfo === part.id"
                >
                  <img
                    :src="imageAssetPath + 'img/icon-neuro.svg'"
                    class="explore-icon"
                    alt=""
                  />
                  <span class="text-area">{{ part.title }} </span>
                  <img
                    v-show="selectedInfo === part.id"
                    :src="[
                      part.id === 'eia'
                        ? imageAssetPath + 'img/icon-minus-black.svg'
                        : imageAssetPath + 'img/icon-minus.svg',
                    ]"
                    class="expand-minus-button"
                    alt="Go back"
                  />
                </div>
              </button>
            </div>

            <button
              class="dropDown-button"
              @click="toggleInfo('')"
              v-show="
                (selectedInfo === 'function' ||
                  selectedInfo === 'depression' ||
                  selectedInfo === 'fatigue') &&
                  selectedInfo != '' &&
                  expandedItem === ''
              "
            >
              <div class="expand-subheading dp-button-menu">
                <img
                  :src="imageAssetPath + 'img/icon-neuro.svg'"
                  class="explore-icon"
                  alt=""
                />
                <span class="text-area">Neuropsychological</span>
                <img
                  :src="imageAssetPath + 'img/icon-minus.svg'"
                  class="expand-minus-button"
                  alt=""
                />
              </div>
            </button>
            <button
              class="dropDown-button"
              @click="toggleInfo('')"
              v-show="
                (selectedInfo === 'pain' || selectedInfo === 'impairment') &&
                  selectedInfo != '' &&
                  expandedItem === ''
              "
            >
              <div class="expand-subheading dp-button-menu">
                <img
                  :src="imageAssetPath + 'img/icon-sensory.svg'"
                  class="explore-icon"
                  alt=""
                />
                <span class="text-area">Sensory System</span>
                <img
                  :src="imageAssetPath + 'img/icon-minus.svg'"
                  class="expand-minus-button"
                  alt=""
                />
              </div>
            </button>
            <button
              v-show="selectedInfo === ''"
              @click="toggleButton('sensory')"
              class="explore-button"
            >
              <img
                :src="imageAssetPath + 'img/icon-sensory.svg'"
                class="explore-icon"
                alt=""
              />
              <span class="explore-label">Sensory System</span>
              <img
                :src="imageAssetPath + 'img/L-Arrow-Down.svg'"
                class="explore-plus-minus"
                alt=""
              />
            </button>
            <div v-show="expandedItem === 'sensory'">
              <button
                v-show="selectedInfo === '' || selectedInfo === part.id"
                v-for="part of sensorySystem"
                :key="part.id"
                @click="toggleInfo(part.id)"
                :class="[`${part.id}`]"
                class="explore-button-other"
              >
                <div class="explore-subheading" v-show="selectedInfo === ''">
                  {{ part.label }}
                  <img
                    v-show="selectedInfo === ''"
                    :src="[
                      part.id === 'eia'
                        ? imageAssetPath + 'img/icon-plus-black.svg'
                        : imageAssetPath + 'img/L-Boxed-Plus-Button.svg',
                    ]"
                    class="explore-plus-button"
                    alt=""
                  />
                </div>

                <div
                  class="expand-subheading"
                  v-show="selectedInfo === part.id"
                >
                  <img
                    :src="imageAssetPath + 'img/icon-sensory.svg'"
                    class="explore-icon"
                    alt=""
                  />
                  <div class="text-area">
                    {{ part.title }}
                  </div>
                  <img
                    v-show="selectedInfo === part.id"
                    :src="[
                      part.id === 'eia'
                        ? imageAssetPath + 'img/icon-minus-black.svg'
                        : imageAssetPath + 'img/icon-minus.svg',
                    ]"
                    class="expand-minus-button"
                    alt="Go back"
                  />
                </div>
              </button>
            </div>

            <button
              v-show="selectedInfo === '' || selectedInfo === part.id"
              v-for="part of vision"
              :key="part.id"
              @click="toggleInfo(part.id)"
              :class="[`${part.id}`]"
              class="explore-button"
            >
              <img
                :src="imageAssetPath + 'img/icon-vision.svg'"
                class="explore-icon"
                alt
              />
              <span class="explore-label">{{ part.label }}</span>
              <img
                v-show="selectedInfo === ''"
                :src="[
                  part.id === 'eia'
                    ? imageAssetPath + 'img/icon-plus-black.svg'
                    : imageAssetPath + 'img/icon-plus.svg',
                ]"
                class="explore-plus-minus"
                alt=""
              />
              <img
                v-show="selectedInfo === 'vision'"
                :src="[
                  part.id === 'eia'
                    ? imageAssetPath + 'img/icon-minus-black.svg'
                    : imageAssetPath + 'img/icon-minus.svg',
                ]"
                class="explore-plus-minus"
                alt="Go back"
              />
            </button>

            <InfoContent
              v-show="selectedInfo === 'eia'"
              @close-info="toggleInfo('')"
              class="eia"
            >
              <p>
                Early inflammation in MS can disrupt the blood-brain barrier
                (BBB) that normally protects the brain. This leakage of the BBB
                allows autoreactive B&nbsp;cells and T&nbsp;cells to enter the
                central nervous system (CNS) and attack myelin and other CNS
                structures.<sup>1</sup>
              </p>
              <!-- <img @click="$store.toggleModal('mobile-video')" class="video-thumb" src="~@/assets/img/mobile-video-thumb.png" alt="Play video"> -->
              <div class="video-container">
                <video
                  :poster="
                    imageAssetPath + 'img/video-thumbnail-inflammatiom.jpg'
                  "
                  controls
                  disablePictureInPicture
                  controlslist="nodownload"
                  id="videoElement"
                  @canplay="updatePaused"
                  @playing="updatePaused"
                  @pause="updatePaused"
                >
                  <source
                    :src="mediaAssetPath + '/onset-animation.mp4'"
                    type="video/mp4"
                  />
                </video>
                <div class="play-icon-container" v-show="paused" @click="play">
                  <img
                    :src="imageAssetPath + 'img/icon-play-white.svg'"
                    alt=""
                  />
                </div>
              </div>
            </InfoContent>

            <InfoContent
              v-show="selectedInfo === 'brain'"
              @close-info="toggleInfo('')"
              class="brain"
            >
              <p>
                Once thought to be primarily mediated by T&#8209;cell activity,
                emerging research implicates B&#8209;cell activity as a
                contributor to early inflammation in MS.<sup>2</sup>
              </p>
              <router-link
                :to="{ name: 'b-cell' }"
                tag="button"
                class="btn-pathways"
              >
                Tap to View Pathways
                <img
                  :src="imageAssetPath + 'img/tap-icon.svg'"
                  width="24px"
                  height="36px"
                  alt
                />
              </router-link>
              <div class="pathways-mobile">
                <div class="ms-container">
                  <button @click="$store.toggleModal('pathway-1')">
                    View B-Cell<br />Contribution in MS 1
                  </button>
                  <img
                    :src="imageAssetPath + 'img/diagram-pathway-1.jpg'"
                    alt=""
                  />
                </div>
                <div class="ms-container">
                  <button @click="$store.toggleModal('pathway-2')">
                    View B-Cell<br />Contribution in MS 2
                  </button>
                  <img
                    :src="imageAssetPath + 'img/diagram-pathway-2.jpg'"
                    alt=""
                  />
                </div>
                <div class="ms-container">
                  <button @click="$store.toggleModal('pathway-3')">
                    View B-Cell<br />Contribution in MS 3
                  </button>
                  <img
                    :src="imageAssetPath + 'img/diagram-pathway-3.jpg'"
                    alt=""
                  />
                </div>
              </div>
            </InfoContent>

            <InfoContent
              v-show="selectedInfo === 'vision'"
              @close-info="toggleInfo('')"
              class="vision"
            >
              <h2>Optic Neuritis</h2>
              <ul>
                <li>
                  Research shows vision problems are reported in >50% of
                  patients within the first 2 years of diagnosis<sup>7</sup>
                </li>
                <li>
                  This is how the image on the screen might be seen by a patient
                  with optic neuritis, which results from inflammation in the
                  afferent visual pathway<sup>26</sup>
                </li>
                <li>
                  Optic neuritis manifests as partial or complete loss of vision
                  in one eye, and is one of the most common vision problems
                  reported by patients<sup>26</sup>
                </li>
              </ul>
            </InfoContent>

            <InfoContent
              v-show="selectedInfo === 'bladder'"
              @close-info="toggleInfo('')"
              class="bladder"
            >
              <h2>Bladder Symptoms</h2>
              <p>
                Bladder issues are reported in close to 50% of patients within
                the first 2 years of diagnosis.<sup>7</sup> The most common
                early symptoms in MS include urgency, frequency, and
                incontinence, and likely involve corticospinal tracts.<sup
                  >8</sup
                >
              </p>
            </InfoContent>

            <InfoContent
              v-show="selectedInfo === 'sensory'"
              @close-info="toggleInfo('')"
              class="sensory"
            >
              <h2>Sensory Impairment</h2>
              <p>
                Sensory impairments are reported in up to approximately 82% of
                patients within the first year of diagnosis.<sup>7</sup>
              </p>
              <p>
                <strong>Paresthesia (abnormal sensation)</strong> is one of the
                most common early sensory symptoms in MS, and is caused by
                either cortical or spinal cord lesions.<sup>25</sup>
              </p>
            </InfoContent>

            <InfoContent
              v-show="selectedInfo === 'musculo'"
              @close-info="toggleInfo('')"
              class="musculo"
            >
              <h2>Muscle Spasticity</h2>
              <p>
                <strong>Spasticity</strong>, manifested as involuntary muscle
                contractions, is reported in nearly 70% of MS patients within
                the first 3 years of diagnosis.<sup class="sup-space"
                  >7, 12</sup
                >
                It is one of the most common early symptoms, potentially
                reflecting neuroinflammation and damage in the motor
                circuitry.<sup>12</sup>
              </p>
            </InfoContent>

            <!-- SENSORY SYSTEM CONTENT -->
            <InfoContent
              v-show="selectedInfo === 'impairment'"
              @close-info="toggleInfo('')"
              class="impairment secondary"
            >
              <h2>Sensory Impairment</h2>
              <p>
                Sensory impairments are reported in up to approximately 82% of
                patients within the first year of diagnosis.<sup>7</sup>
              </p>
              <p>
                <strong>Paresthesia (abnormal sensation)</strong> is one of the
                most common early sensory symptoms in MS, and is caused by
                either cortical or spinal cord lesions.<sup>25</sup>
              </p>
            </InfoContent>

            <InfoContent
              v-show="selectedInfo === 'pain'"
              @close-info="toggleInfo('')"
              class="pain secondary"
            >
              <h2>Pain</h2>
              <p>
                Pain is another common symptom and has been reported by up to
                75% of patients with MS.<sup>22</sup>
              </p>
              <p>Pain associated with MS may be categorized as:</p>
              <ol>
                <li>
                  Neuropathic, resulting from demyelinating lesions<sup
                    >22,23</sup
                  >
                </li>
                <li>
                  Nociceptive, resulting from activation of nociceptors in the
                  periphery due to tissue damage<sup>22,23</sup>
                </li>
                <li>
                  Nociplastic, resulting from altered nociception despite no
                  tissue damage, also known as centralized pain of central
                  sensitization<sup>23</sup>
                </li>
              </ol>
              <p>
                Pain presentation is highly variable across patients and is one
                of the most disabling symptoms in MS.<sup>23,24</sup>
              </p>
            </InfoContent>

            <!-- Neuropsychological -->
            <InfoContent
              v-show="selectedInfo === 'fatigue'"
              @close-info="toggleInfo('')"
              class="fatigue secondary"
            >
              <h2>Fatigue</h2>
              <p>
                Fatigue is one of the most common symptoms in patients with MS,
                with an estimated 80-90% prevalence.<sup>19</sup> It has a
                considerable impact on quality of life, with 55% of patients
                with MS reporting it as one of their worst symptoms, often
                independent of measurable disease activity.<sup>20</sup>
              </p>
              <p>
                Primary fatigue is due to active inflammatory disease, while
                secondary fatigue is a consequence of other factors including
                medications, stress, depression, and sleep problems.<sup
                  >21</sup
                >
              </p>
            </InfoContent>
            <InfoContent
              v-show="selectedInfo === 'function'"
              @close-info="toggleInfo('')"
              class="function secondary"
            >
              <h2>Cognitive Function</h2>
              <p>
                Cognitive impairment can affect up to 70% of patients with
                MS.<sup>13</sup> Cognitive deficits are likely present in the
                early stages of MS in most patients,<sup>14</sup> may predate
                neurological abnormalities, and worsens over the disease
                course.<sup>13,15</sup>
              </p>
              <p>
                Impairment mostly affects executive functioning abilities
                including attention, information processing speed and long-term
                memory.<sup>13</sup> Cognitive impairment is associated with a
                negative impact on quality of life and daily functioning in
                patients with MS.<sup>13,14</sup>
              </p>
            </InfoContent>
            <InfoContent
              v-show="selectedInfo === 'depression'"
              @close-info="toggleInfo('')"
              class="depression secondary"
            >
              <h2>Depression</h2>
              <p>
                Prevalence of clinically significant depression is shown to
                occur in approximately 35% of patients with MS.<sup>17</sup>
                Patients with MS often experience symptoms in association with
                depression, such as fatigue, pain, and cognitive impairment.<sup
                  >18</sup
                >
              </p>
              <p>
                Depression and anxiety in MS patients is related to lower
                quality of life, cognitive dysfunction, elevated suicide risk,
                and work issues.<sup>17</sup> It can also have a negative impact
                on the compliance of patients taking disease-modifying
                treatments.<sup>18</sup>
              </p>
            </InfoContent>
          </div>
        </div>
        <div class="content-right">
          <div class="asset-toggle-container" key="asset-toggle">
            <button @click="toggleAsset('leftView')" class="toggle-btn left">
              <img
                :src="imageAssetPath + 'img/arrow-right-icon-black.svg'"
                alt
              />
              <span>Left</span>
            </button>
            <button
              @click="toggleAsset('centreView')"
              class="toggle-btn centre"
            >
              Front
            </button>
            <button @click="toggleAsset('rightView')" class="toggle-btn right">
              <span>Right</span>
              <img
                :src="imageAssetPath + 'img/arrow-right-icon-black.svg'"
                alt
              />
            </button>
          </div>
          <VideoContent>
            <transition-group name="model-fade">
              <!-- ASSETS FOR MAIN PAGE -->
              <img
                key="default-left"
                v-show="
                  (selectedInfo === '' || selectedInfo === 'eia') &&
                    selectedAssetView === 'leftView'
                "
                :src="imageAssetPath + 'img/Shot02_Statue_Main_Transparent.png'"
                title="Statue of systems impacted by MS, including the brain, urinary, musculoskeletal, and nervous systems"
                alt="Statue of symptoms impacted by MS, including the nervous, urinary and musculoskeletal systems."
              />
              <img
                key="default"
                v-show="
                  (selectedInfo === '' || selectedInfo === 'eia') &&
                    selectedAssetView === 'centreView'
                "
                :src="imageAssetPath + 'img/Statue_Main_Transparent.png'"
                title="Statue of systems impacted by MS, including the brain, urinary, musculoskeletal, and nervous systems"
                alt="Statue of symptoms impacted by MS, including the nervous, urinary and musculoskeletal systems."
              />
              <img
                key="default-right"
                v-show="
                  (selectedInfo === '' || selectedInfo === 'eia') &&
                    selectedAssetView === 'rightView'
                "
                :src="imageAssetPath + 'img/Shot03_Statue_Main_Transparent.png'"
                title="Statue of systems impacted by MS, including the brain, urinary, musculoskeletal, and nervous systems"
                alt="Statue of symptoms impacted by MS, including the nervous, urinary and musculoskeletal systems."
              />

              <!-- ASSETS FOR BRAIN -->
              <video
                key="brain-left"
                v-show="
                  selectedInfo === 'brain' && selectedAssetView === 'leftView'
                "
                id="video-brain"
                playsinline
                loop
                autoplay
                muted
                ref="brain-left"
                @pause="videoPause('brain-left')"
                title="Statue of a woman with electrical activity in brain"
                :poster="
                  imageAssetPath + 'img/Shot02_Statue_Main_Transparent.png'
                "
              >
                <source
                  :src="mediaAssetPath + '/Shot02_Brain_Pulse.mp4'"
                  type="video/mp4"
                  loop
                />
              </video>
              <video
                key="brain-centre"
                v-show="
                  selectedInfo === 'brain' && selectedAssetView === 'centreView'
                "
                id="video-brain"
                playsinline
                loop
                autoplay
                muted
                ref="brain-centre"
                @pause="videoPause('brain-centre')"
                title="Statue of a woman with electrical activity in brain"
                :poster="imageAssetPath + 'img/Statue_Main_Solid.png'"
              >
                <source
                  :src="mediaAssetPath + '/Statue_Brain_Pulse.mp4'"
                  type="video/mp4"
                  loop
                />
              </video>

              <video
                key="brain-right"
                v-show="
                  selectedInfo === 'brain' && selectedAssetView === 'rightView'
                "
                id="video-brain"
                playsinline
                loop
                autoplay
                muted
                ref="brain-right"
                @pause="videoPause('brain-right')"
                title="Statue of a woman with electrical activity in brain"
                :poster="
                  imageAssetPath + 'img/Shot03_Statue_Main_Transparent.png'
                "
              >
                <source
                  :src="mediaAssetPath + '/Shot03_Brain_Pulse.mp4'"
                  type="video/mp4"
                  loop
                />
              </video>

              <!-- ASSETS FOR VISION -->
              <img
                key="vision-left"
                v-show="
                  selectedInfo === 'vision' && selectedAssetView === 'leftView'
                "
                :src="imageAssetPath + 'img/Shot02_Statue_Main_Blurry.png'"
                title="Blurry statue of a woman"
              />
              <img
                key="vision-centre"
                v-show="
                  selectedInfo === 'vision' &&
                    selectedAssetView === 'centreView'
                "
                :src="imageAssetPath + 'img/Statue_Main_Blurry.png'"
                title="Blurry statue of a woman"
              />
              <img
                key="vision-right"
                v-show="
                  selectedInfo === 'vision' && selectedAssetView === 'rightView'
                "
                :src="imageAssetPath + 'img/Shot03_Statue_Main_Blurry.png'"
                title="Blurry statue of a woman"
              />

              <!-- ASSETS FOR BLADDER -->
              <img
                key="bladder-left"
                v-show="
                  selectedInfo === 'bladder' && selectedAssetView === 'leftView'
                "
                :src="
                  imageAssetPath + 'img/Shot02_Statue_Bladder_Highlighted.png'
                "
                title="Statue of a woman with bladder highlighted"
              />
              <img
                key="bladder-centre"
                v-show="
                  selectedInfo === 'bladder' &&
                    selectedAssetView === 'centreView'
                "
                :src="imageAssetPath + 'img/Statue_Bladder_Highlighted.png'"
                title="Statue of a woman with bladder highlighted"
              />
              <img
                key="bladder-right"
                v-show="
                  selectedInfo === 'bladder' &&
                    selectedAssetView === 'rightView'
                "
                :src="
                  imageAssetPath + 'img/Shot03_Statue_Bladder_Highlighted.png'
                "
                title="Statue of a woman with bladder highlighted"
              />

              <!-- ASETS FOR SENSORY SYSTEM -->
              <!-- <video
                key="sensory-left"
                v-show="
                  selectedInfo === 'sensory' && selectedAssetView === 'leftView'
                "
                id="video-sensory"
                playsinline
                loop
                autoplay
                muted
                ref="sensory-left"
                @pause="videoPause('sensory-left')"
                title="Statue of a woman with electrical signals going from the brain down her arm"
                poster="/img/Shot02_Statue_Main_Transparent.png"
              >
                <source
                  src="/videos/Shot02_Arm_Pulse.mp4"
                  type="video/mp4"
                  loop
                />
              </video>
              <video
                key="sensory-centre"
                v-show="
                  selectedInfo === 'sensory' &&
                  selectedAssetView === 'centreView'
                "
                id="video-sensory"
                playsinline
                loop
                autoplay
                muted
                ref="sensory-centre"
                @pause="videoPause('sensory-centre')"
                title="Statue of a woman with electrical signals going from the brain down her arm"
                poster="/img/Statue_Main_Solid.png"
              >
                <source
                  src="/videos/Statue_Arm_Pulse.mp4"
                  type="video/mp4"
                  loop
                />
              </video>
              <video
                key="sensory-right"
                v-show="
                  selectedInfo === 'sensory' &&
                  selectedAssetView === 'rightView'
                "
                id="video-sensory"
                playsinline
                loop
                autoplay
                muted
                ref="sensory-right"
                @pause="videoPause('sensory-right')"
                title="Statue of a woman with electrical signals going from the brain down her arm"
                poster="/img/Shot03_Statue_Main_Transparent.png"
              >
                <source
                  src="/videos/Shot03_Arm_Pulse.mp4"
                  type="video/mp4"
                  loop
                />
              </video> -->

              <!-- ASSETS FOR MUSCULOSKELETAL -->
              <video
                key="musculo-left"
                v-show="
                  selectedInfo === 'musculo' && selectedAssetView === 'leftView'
                "
                id="video-musculo"
                playsinline
                loop
                autoplay
                muted
                ref="musculo-left"
                @pause="videoPause('musculo-left')"
                title="Statue of a woman with electrical signals going from the brain down her leg"
                :poster="
                  imageAssetPath + 'img/Shot02_Statue_Main_Transparent.png'
                "
              >
                <source
                  :src="mediaAssetPath + '/Shot02_Leg_Pulse.mp4'"
                  type="video/mp4"
                  loop
                />
              </video>
              <video
                key="musculo"
                v-show="
                  selectedInfo === 'musculo' &&
                    selectedAssetView === 'centreView'
                "
                id="video-musculo"
                playsinline
                loop
                autoplay
                muted
                ref="musculo-centre"
                @pause="videoPause('musculo-centre')"
                title="Statue of a woman with electrical signals going from the brain down her leg"
                :poster="imageAssetPath + 'img/Statue_Main_Solid.png'"
              >
                <source
                  :src="mediaAssetPath + '/Statue_Leg_Pulse.mp4'"
                  type="video/mp4"
                  loop
                />
              </video>
              <video
                key="musculo-right"
                v-show="
                  selectedInfo === 'musculo' &&
                    selectedAssetView === 'rightView'
                "
                id="video-musculo"
                playsinline
                loop
                autoplay
                muted
                ref="musculo-right"
                @pause="videoPause('musculo-right')"
                title="Statue of a woman with electrical signals going from the brain down her leg"
                :poster="
                  imageAssetPath + 'img/Shot03_Statue_Main_Transparent.png'
                "
              >
                <source
                  :src="mediaAssetPath + '/Shot03_Leg_Pulse.mp4'"
                  type="video/mp4"
                  loop
                />
              </video>

              <!-- ASETS FOR DEPRESSION -->
              <video
                key="depression-left"
                v-show="
                  selectedInfo === 'depression' &&
                    selectedAssetView === 'leftView'
                "
                id="video-depression"
                playsinline
                autoplay
                muted
                title="Statue of a woman that turns dull gray and cracks"
                ref="depression-left"
                @pause="videoPause('depression-left')"
                :poster="
                  imageAssetPath + 'img/Shot02_Statue_Main_Transparent.png'
                "
              >
                <source
                  :src="mediaAssetPath + '/Statue_Depression_left.mp4'"
                  type="video/mp4"
                />
              </video>
              <video
                key="depression"
                v-show="
                  selectedInfo === 'depression' &&
                    selectedAssetView === 'centreView'
                "
                id="video-depression"
                playsinline
                autoplay
                muted
                title="Statue of a woman that turns dull gray and cracks"
                ref="depression-centre"
                @pause="videoPause('depression-centre')"
                :poster="imageAssetPath + 'img/Statue_Main_Solid.png'"
              >
                <source
                  :src="mediaAssetPath + '/Statue_Depression_centre.mp4'"
                  type="video/mp4"
                />
              </video>
              <video
                key="depression-right"
                v-show="
                  selectedInfo === 'depression' &&
                    selectedAssetView === 'rightView'
                "
                id="video-depression"
                playsinline
                autoplay
                muted
                title="Statue of a woman that turns dull gray and cracks"
                ref="depression-right"
                @pause="videoPause('depression-right')"
                :poster="
                  imageAssetPath + 'img/Shot03_Statue_Main_Transparent.png'
                "
              >
                <source
                  :src="mediaAssetPath + '/Statue_Depression_right.mp4'"
                  type="video/mp4"
                />
              </video>

              <!-- ASETS FOR FATIGUE -->
              <video
                key="fatigue-left"
                v-show="
                  selectedInfo === 'fatigue' && selectedAssetView === 'leftView'
                "
                id="video-fatigue"
                playsinline
                autoplay
                muted
                ref="fatigue-left"
                @pause="videoPause('fatigue-left')"
                title="Statue of a woman turning her head downwards as she sinks into mud"
                :poster="
                  imageAssetPath + 'img/Shot02_Statue_Main_Transparent.png'
                "
              >
                <source
                  :src="mediaAssetPath + '/Statue_Fatigue_Cam02.mp4'"
                  type="video/mp4"
                />
              </video>
              <video
                key="fatigue"
                v-show="
                  selectedInfo === 'fatigue' &&
                    selectedAssetView === 'centreView'
                "
                id="video-fatigue"
                playsinline
                autoplay
                muted
                ref="fatigue-centre"
                @pause="videoPause('fatigue-centre')"
                title="Statue of a woman turning her head downwards as she sinks into mud"
                :poster="imageAssetPath + 'img/Statue_Main_Solid.png'"
              >
                <source
                  :src="mediaAssetPath + '/Statue_Fatigue_Cam01.mp4'"
                  type="video/mp4"
                />
              </video>
              <video
                key="fatigue-right"
                v-show="
                  selectedInfo === 'fatigue' &&
                    selectedAssetView === 'rightView'
                "
                id="video-fatigue"
                playsinline
                autoplay
                muted
                ref="fatigue-right"
                @pause="videoPause('fatigue-right')"
                title="Statue of a woman turning her head downwards as she sinks into mud"
                :poster="
                  imageAssetPath + 'img/Shot03_Statue_Main_Transparent.png'
                "
              >
                <source
                  :src="mediaAssetPath + '/Statue_Fatigue_Cam03.mp4'"
                  type="video/mp4"
                />
              </video>
              <!-- ASETS FOR CognitiveFunction-->
              <video
                key="function-left"
                v-show="
                  selectedInfo === 'function' &&
                    selectedAssetView === 'leftView'
                "
                id="video-function"
                playsinline
                autoplay
                muted
                ref="function-left"
                @pause="videoPause('function-left')"
                title="Statue of a woman surrounded by clouds with sentence fragments. Words then rearrange to say “Issues with my memory, attention, and problem solving have had a major impact on my life.” "
                :poster="
                  imageAssetPath + 'img/Shot02_Statue_Main_Transparent.png'
                "
              >
                <source
                  :src="mediaAssetPath + '/Statue_CognitiveFunction_Cam02.mp4'"
                  type="video/mp4"
                />
              </video>

              <video
                key="function"
                v-show="
                  selectedInfo === 'function' &&
                    selectedAssetView === 'centreView'
                "
                id="video-function"
                playsinline
                autoplay
                muted
                ref="function-centre"
                @pause="videoPause('function-centre')"
                title="Statue of a woman surrounded by clouds with sentence fragments. Words then rearrange to say “Issues with my memory, attention, and problem solving have had a major impact on my life.” "
                :poster="imageAssetPath + 'img/Statue_Main_Solid.png'"
              >
                <source
                  :src="mediaAssetPath + '/Statue_CognitiveFunction_Cam01.mp4'"
                  type="video/mp4"
                />
              </video>
              <video
                key="function-right"
                v-show="
                  selectedInfo === 'function' &&
                    selectedAssetView === 'rightView'
                "
                id="video-function"
                playsinline
                autoplay
                muted
                ref="function-right"
                @pause="videoPause('function-right')"
                title="Statue of a woman surrounded by clouds with sentence fragments. Words then rearrange to say “Issues with my memory, attention, and problem solving have had a major impact on my life.” "
                :poster="
                  imageAssetPath + 'img/Shot03_Statue_Main_Transparent.png'
                "
              >
                <source
                  :src="mediaAssetPath + '/Statue_CognitiveFunction_Cam03.mp4'"
                  type="video/mp4"
                />
              </video>
              <!-- ASETS FOR Pain-->
              <video
                key="pain-left"
                v-show="
                  selectedInfo === 'pain' && selectedAssetView === 'leftView'
                "
                id="video-pain"
                playsinline
                autoplay
                muted
                title="Statue of a woman turning her head downwards with red pain signals going from the brain down her arms and leg, ending in throbbing limbs."
                ref="ss-pain-left"
                @pause="videoPause('ss-pain-left')"
                :poster="
                  imageAssetPath + 'img/Shot02_Statue_Main_Transparent.png'
                "
              >
                <source
                  :src="mediaAssetPath + '/Statue_Pain_Cam02.mp4'"
                  type="video/mp4"
                />
              </video>

              <video
                key="pain"
                v-show="
                  selectedInfo === 'pain' && selectedAssetView === 'centreView'
                "
                id="video-pain"
                playsinline
                autoplay
                muted
                title="Statue of a woman turning her head downwards with red pain signals going from the brain down her arms and leg, ending in throbbing limbs."
                ref="ss-pain-centre"
                @pause="videoPause('ss-pain-centre')"
                :poster="imageAssetPath + 'img/Statue_Main_Solid.png'"
              >
                <source
                  :src="mediaAssetPath + '/Statue_Pain_Cam01.mp4'"
                  type="video/mp4"
                />
              </video>
              <video
                key="pain-right"
                v-show="
                  selectedInfo === 'pain' && selectedAssetView === 'rightView'
                "
                id="video-pain"
                playsinline
                autoplay
                muted
                title="Statue of a woman turning her head downwards with red pain signals going from the brain down her arms and leg, ending in throbbing limbs."
                ref="ss-pain-right"
                @pause="videoPause('ss-pain-right')"
                :poster="
                  imageAssetPath + 'img/Shot03_Statue_Main_Transparent.png'
                "
              >
                <source
                  :src="mediaAssetPath + '/Statue_Pain_Cam03.mp4'"
                  type="video/mp4"
                />
              </video>

              <!-- SENSORY IMPAIRMENT -->
              <video
                key="impairment-left"
                v-show="
                  selectedInfo === 'impairment' &&
                    selectedAssetView === 'leftView'
                "
                id="video-impairment"
                playsinline
                loop
                autoplay
                muted
                ref="ss-impairement-left"
                @pause="videoPause('ss-impairement-left')"
                title="Statue of a woman with electrical signals going from the brain down her arm"
                :poster="
                  imageAssetPath + 'img/Shot02_Statue_Main_Transparent.png'
                "
              >
                <source
                  :src="mediaAssetPath + '/Shot02_Arm_Pulse.mp4'"
                  type="video/mp4"
                  loop
                />
              </video>
              <video
                key="impairment-centre"
                v-show="
                  selectedInfo === 'impairment' &&
                    selectedAssetView === 'centreView'
                "
                id="video-impairment"
                playsinline
                loop
                autoplay
                muted
                ref="ss-impairement-centre"
                @pause="videoPause('ss-impairement-centre')"
                title="Statue of a woman with electrical signals going from the brain down her arm"
                :poster="imageAssetPath + 'img/Statue_Main_Solid.png'"
              >
                <source
                  :src="mediaAssetPath + '/Statue_Arm_Pulse.mp4'"
                  type="video/mp4"
                  loop
                />
              </video>
              <video
                key="impairment-right"
                v-show="
                  selectedInfo === 'impairment' &&
                    selectedAssetView === 'rightView'
                "
                id="video-impairment"
                playsinline
                loop
                autoplay
                muted
                ref="ss-impairement-right"
                @pause="videoPause('ss-impairement-right')"
                title="Statue of a woman with electrical signals going from the brain down her arm"
                :poster="
                  imageAssetPath + 'img/Shot03_Statue_Main_Transparent.png'
                "
              >
                <source
                  :src="mediaAssetPath + '/Shot03_Arm_Pulse.mp4'"
                  type="video/mp4"
                  loop
                />
              </video>
            </transition-group>
          </VideoContent>
          <!-- 
          <div class="back-mobile">
            <router-link
              :to="{ name: 'home' }"
              @click.native="
                $gtag.event('click', {
                  event_category: 'back_to_start',
                  event_label: 'back',
                })
              "
              class="back-link"
            >
              <button class="back-button">
                <img src="/img/arrow-back-icon-black.svg" alt />
                Back to start
              </button>
            </router-link>
          </div>
           -->
        </div>
      </div>
    </InnerContent>
    <Modal
      class="modal"
      id="pathway1"
      v-if="$store.state.showModal === 'pathway-1'"
    >
      <div slot="content">
        <img
          :src="imageAssetPath + 'img/diagram-pathway-1.jpg'"
          alt="Once B-cells cross the blood–brain barrier, they can transform into antigen-presenting cells. These antigen-presenting cells then bind to autoreactive C D 4 plus T-cells within the central nervous system, activating them to release proinflammatory cytokines. Proinflammatory cytokine release contributes to damage of the myelin sheath and may impair oligodendrocyte activity."
        />
      </div>
    </Modal>
    <Modal
      class="modal"
      id="pathway2"
      v-if="$store.state.showModal === 'pathway-2'"
    >
      <div slot="content">
        <img
          :src="imageAssetPath + 'img/diagram-pathway-2.jpg'"
          alt="Within the central nervous system, B-cells can be activated to directly release proinflammatory cytokines, contributing to autoreactive damage to myelin and other components of the central nervous system."
        />
      </div>
    </Modal>
    <Modal
      class="modal"
      id="pathway3"
      v-if="$store.state.showModal === 'pathway-3'"
    >
      <div slot="content">
        <img
          :src="imageAssetPath + 'img/diagram-pathway-3.jpg'"
          alt="Inside the central nervous system, B-cells can transform into antibody-producing plasma cells. These plasma cells release autoantibodies, which may promote axonal damage and complement-mediated demyelination through antigen-binding activity."
        />
      </div>
    </Modal>
  </div>
</template>

<script>
import VideoContent from "@/components/VideoContent";
import InfoContent from "@/components/InfoContent";
import Modal from "@/components/Modal";

export default {
  name: "Exploration",
  components: {
    VideoContent,
    InfoContent,
    Modal,
  },

  data() {
    return {
      videoElement: null,
      paused: null,
      activeVideo: "static",
      expandedItem: "",
      selectedInfo: "",
      selectedAssetView: "centreView",
      imageAssetPath: "/",
      mediaAssetPath: "/",
      // videos: ["static", "brain", "vision", "bladder", "sensory", "musculo"],
      videos: [
        "static",
        "bladder",
        "brain",
        "musculo",
        "sensory",
        "vision",
        "depression",
      ],
      // infos: ["eia", "brain", "vision", "bladder", "sensory", "musculo"],
      infos: [
        "eia",
        "bladder",
        "brain",
        "musculo",
        "sensory",
        "vision",
        "depression",
      ],
      coolDown: false,
      bodyparts: [
        {
          id: "eia",
          label: "Early Inflammation Activity",
          alt: "More about the early inflammation activity",
        },
        {
          id: "bladder",
          label: "Bladder",
          alt: "More about the bladder",
        },
        {
          id: "brain",
          label: "Brain",
          alt: "More about the brain",
        },
        {
          id: "musculo",
          label: "Musculoskeletal System",
          alt: "More about the musculoskeletal system",
        },
      ],
      neuropsychological: [
        {
          id: "function",
          label: "Cognitive Function",
          title: "Neuropsychological",
          alt: "More about cognitive function",
        },
        {
          id: "depression",
          label: "Depression",
          title: "Neuropsychological",
          alt: "More about depression",
        },
        {
          id: "fatigue",
          label: "Fatigue",
          title: "Neuropsychological",
          alt: "More about fatigue",
        },
      ],
      sensorySystem: [
        {
          id: "pain",
          label: "Pain",
          title: "Sensory System",
          alt: "More about pain",
        },
        {
          id: "impairment",
          label: "Sensory Impairment",
          title: "Sensory System",
          alt: "More about sensory Impairment",
        },
      ],
      vision: [
        {
          id: "vision",
          label: "Vision",
          alt: "More about vision",
        },
      ],
    };
  },
  computed: {
    playing() {
      return !this.paused;
    },
  },
  watch: {
    selectedInfo(newVal) {
      this.$store.updateLastExplore(newVal);
    },
  },
  mounted() {
    console.log("url>>", process.env.NODE_ENV);
    if (process.env.NODE_ENV === "development") {
      this.imageAssetPath = "";
      this.mediaAssetPath = "videos";
    } else {
      this.imageAssetPath = "";
      this.mediaAssetPath = "media";
    }
  },
  beforeMount() {
    this.toggleInfo(this.$store.state.lastExplore);
  },
  methods: {
    videoPause(id) {
      this.$refs[id].currentTime = 0;
    },
    toggleInfo(partId) {
      this.toggleButton();
      if (this.selectedInfo === partId || partId === "") {
        this.selectedInfo = "";
        this.selectedAssetView = "centreView";
      } else {
        this.selectedInfo = partId;
        this.selectedAssetView = "centreView";

        this.$gtag.event("click", {
          event_category: "select_subsection",
          event_label: partId,
          // event_label: this.bodyparts.find(({ id }) => id === partId).label,
        });
      }
    },
    toggleAsset(view) {
      if (this.selectedAssetView !== view) {
        if (this.coolDown === false) {
          this.selectedAssetView = view;
          this.coolDown = true;
          let self = this;
          setTimeout(function() {
            self.coolDown = false;
          }, 500);
        }
      }
    },
    toggleButton(item) {
      this.expandedItem = this.expandedItem === item ? "" : item;
    },
    updatePaused(event) {
      this.videoElement = event.target;
      this.paused = event.target.paused;
    },
    play() {
      this.videoElement.play();
    },
    pause() {
      this.videoElement.pause();
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/scss/styles.scss";

#exploration {
  width: 100%;
  position: relative;

  .inner-content {
    padding-bottom: 20px;
  }
}

.content-header {
  margin: 20px auto;
  display: flex;
  align-items: center;
  justify-content: flex-end;

  @include breakpoint(sm) {
    margin: 20px 0 0;
  }

  @include breakpoint(md) {
    //width: 319px;
    margin: 20px 0 0;
  }
}

.back-mobile {
  display: none;
}

@media only screen and (max-width: 767px) {
  .back-mobile {
    border: 0;
    padding: 0;
    font-size: rem(14px);
    background-color: transparent;
    margin: 10px 0;
    display: flex;
    justify-content: flex-end;
    img {
      width: 23px;
      height: 20px;
      margin-right: 10px;
    }
    .back-button {
      border: 0;
      padding: 0;
      font-size: rem(14px);
      background-color: transparent;
      width: 130px;
      height: 40px;
    }
  }
  .back {
    display: none;
  }
  .explore-button-other {
    min-width: 100% !important;
  }
  .expand-subheading {
    height: 44px !important;
  }
}

.content {
  display: flex;
  justify-content: space-between;
  margin: 0 auto;

  @include breakpoint(xs) {
    flex-direction: column-reverse;
  }

  @include breakpoint(sm) {
    flex-direction: column-reverse;
  }

  @include breakpoint(md) {
    flex-direction: column-reverse;
    // border: 1px solid black;
    position: relative;
    min-height: 800px;
  }
}

.sup-space {
  white-space: nowrap;
}

.content-left {
  width: 50%;
  margin-right: 20px;
  display: block;

  @include breakpoint(md) {
    width: 100%;
    margin-right: 0;
  }

  @include breakpoint(sm) {
    width: 100%;
    margin-right: 0;
  }

  @include breakpoint(xs) {
    width: 100%;
    margin-right: 0;
  }

  .content-copy {
    width: 447px;

    @include breakpoint(md) {
      width: 100%;
    }

    @include breakpoint(sm) {
      width: 100%;
    }

    @include breakpoint(xs) {
      width: 100%;
    }
  }

  .app-title {
    font-size: rem(42px);
    line-height: rem(50px);
    font-weight: $font-weight-bold;
    // color: $blue;
    margin-bottom: 20px;

    @include breakpoint(xs) {
      font-size: rem(30px);
      line-height: rem(30px);
      margin-top: 13px;
    }

    @include breakpoint(sm) {
      font-size: rem(45px);
      line-height: rem(50px);
      margin-top: 60px;
    }
  }
}

.content-right {
  //width: 50%;
  display: flex;
  justify-content: center;
  flex-direction: column;

  @include breakpoint(md) {
    margin: 0 auto;
    right: 50%;
    top: -40px;
    // height: 880px;
    // height: 680px
  }

  @include breakpoint(sm) {
    // margin: 0 auto;
    // right: 50%;
    // top: -40px;
    // height: 680px;
    // width: 55%;
  }

  @include breakpoint(xs) {
    // margin: 0 auto;
  }

  video,
  img {
    height: 768px;

    @include breakpoint(sm) {
      //@extendwidth: 100%;
      height: 668px;
    }

    @include breakpoint(md) {
      // width: 100%;
      height: auto;
    }
  }
}

a {
  text-decoration: none;
}

.back-link {
  display: flex;
  //width: 130px;
}

button {
  font-weight: $font-weight-bold;
  display: flex;
  align-items: center;
  font-size: rem(20px);

  @include breakpoint(xs) {
    font-size: rem(14px);
  }

  @include breakpoint(sm) {
    font-size: rem(14px);
  }

  @include breakpoint(md) {
    font-size: rem(16px);
  }

  .arrow {
    display: inline-block;
    height: 20px;
    margin-left: 10px;
  }

  &.back {
    border: 0;
    padding: 0;
    font-size: rem(14px);
    background-color: transparent;
    width: 130px;
    img {
      margin-right: 10px;
    }
    @include breakpoint(md) {
      &.back {
        margin-left: 420px;
      }
    }
  }

  &.modal-button {
    border: 2px solid $black;
    padding: 0 1rem;
    background-color: transparent;
    width: 100%;
    min-width: 409.69px;
    height: 76px;
    justify-content: space-between;
    margin-top: 40px;
    margin-bottom: 20px;
    @include breakpoint(xs) {
      display: none;
    }
    @include breakpoint(sm) {
      display: none;
    }
    @include breakpoint(md) {
      display: none;
    }
  }
}

.btn-pathways {
  @include breakpoint(sm) {
    display: none;
  }
}

.asset-toggle-container {
  height: 50px;
  display: flex;
  justify-content: space-around;
  align-items: center;
  margin-bottom: 7px;
  .toggle-btn {
    height: 100%;
    background: transparent;
    border: none;
    display: flex;
    justify-content: center;
    align-items: top;
    color: $black;

    img {
      width: 10px;
    }
    &.left {
      img {
        height: 100%;
        margin-right: 10px;
        transform: rotate(180deg);
      }
    }
    &.right {
      img {
        height: 100%;
        margin-left: 10px;
      }
    }
  }
}

// placeholder element for assets
.placeholder {
  background: $grey;
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  h1 {
    color: black;
    font-size: rem(60px);
  }
}
.explore-button-other {
  background: none;
  border: none;
  position: relative;
  display: flex;
  justify-content: space-between;
  width: 100%;
  //margin-top: 20px;
  //margin-bottom: 20px;
  padding-left: 50px;
  @include breakpoint(md) {
    padding-left: 0;
  }
  @include breakpoint(xs) {
    padding-left: 0;
  }
  @include breakpoint(sm) {
    padding-left: 0;
  }
}
.explore-subheading {
  display: flex;
  color: $blue-button;
  border-bottom: 1px solid grey;
  justify-content: space-between;
  width: 100%;
  padding: 15px;
  margin-left: 20px;
}
.expand-subheading {
  display: flex;
  justify-content: space-between;
  background-color: $blue-button;
  border: none;
  color: $white;
  //width: 100%;
  width: 445.69px;
  margin-left: -48px;
  height: auto;
  @include breakpoint(md) {
    width: 100%;
    margin: 0 auto;
  }
  @include breakpoint(xs) {
    width: 100%;
    margin: 0 auto;
  }
  @include breakpoint(sm) {
    width: 100%;
    margin: 0 auto;
  }
}
.text-area {
  margin: 17px;
  width: 100%;
  float: left;
  text-align: left;
}
.expand-minus-button {
  margin-right: 5%;
}

.dropDown-button {
  padding: 0px;
}
.dp-button-menu {
  margin-left: 0px;
  padding: 0px;
}

.explore-button {
  position: relative;
  display: flex;
  justify-content: space-between;
  width: 100%;
  min-width: 409.69px;
  padding: 0;
  margin-top: 20px;
  background-color: $blue-button;
  border: none;
  color: $white;
  text-align: left;

  &.eia {
    display: none;
  }

  // &.secondary {
  //   // width: 85%;
  //   min-width: 350px;
  //   margin-left: auto;
  //   @include breakpoint(md) {
  //     width: calc(100% - 58px);
  //   }
  //   @include breakpoint(sm) {
  //     width: calc(100% - 44px);
  //   }
  //   @include breakpoint(xs) {
  //     width: calc(100% - 44px);
  //     min-width: calc(100% - 44px);
  //   }
  // }

  // @include breakpoint(md) {
  //   min-width: auto;
  //   height: 44px;
  //   margin-top: 13px;

  //   &.eia {
  //     display: flex;
  //     border: 2px solid $black;
  //     padding: 0 1rem;
  //     background-color: transparent;
  //     min-width: auto;
  //     height: 44px;
  //     justify-content: space-between;
  //     margin-top: 20px;
  //     margin-bottom: 13px;
  //     color: $black;

  //     .explore-label {
  //       padding-left: 0;
  //     }
  //     .explore-icon {
  //       display: none;
  //     }

  //     .explore-plus-minus {
  //       margin: 0;
  //     }
  //   }
  // }

  // @include breakpoint(xs) {
  //   min-width: 100%;
  // }

  // @include breakpoint(sm) {
  //   min-width: 100%;
  // }

  @include breakpoint(md) {
    // min-width: 308px;
    width: 100%;
    height: 58px;
    margin-top: 13px;

    &.eia {
      display: flex;
      border: 2px solid $black;
      padding: 0 1rem;
      background-color: transparent;
      min-width: auto;
      justify-content: space-between;
      margin-top: 20px;
      margin-bottom: 13px;
      color: $black;

      .explore-label {
        padding-left: 0;
      }
      .explore-icon {
        display: none;
      }

      .explore-plus-minus {
        margin: 0;
      }
    }
    .expand-subheading {
      height: 44px;
    }
  }
  @include breakpoint(sm) {
    min-width: 100%;
    width: 100%;
    height: 44px;
    margin-top: 13px;

    &.eia {
      display: flex;
      border: 2px solid $black;
      padding: 0 1rem;
      background-color: transparent;
      min-width: auto;
      justify-content: space-between;
      margin-top: 20px;
      margin-bottom: 13px;
      color: $black;

      .explore-label {
        padding-left: 0;
      }
      .explore-icon {
        display: none;
      }

      .explore-plus-minus {
        margin: 0;
      }
    }
    .expand-subheading {
      height: 44px;
    }
  }
  @include breakpoint(xs) {
    min-width: 100%;
    width: 100%;
    height: 44px;
    margin-top: 13px;

    &.eia {
      display: flex;
      border: 2px solid $black;
      padding: 0 1rem;
      background-color: transparent;
      min-width: auto;
      justify-content: space-between;
      margin-top: 20px;
      margin-bottom: 13px;
      color: $black;

      .explore-label {
        padding-left: 0;
      }
      .explore-icon {
        display: none;
      }

      .explore-plus-minus {
        margin: 0;
      }
    }
  }
}

.explore-icon {
  flex-shrink: 0;
  height: 60px;

  @include breakpoint(xs) {
    height: 45px;
  }

  @include breakpoint(sm) {
    height: 44px;
  }

  @include breakpoint(md) {
    height: 58px;
  }
}

.explore-label {
  flex-grow: 1;
  padding-left: 20px;
}

.explore-plus-minus {
  flex-shrink: 0;
  width: 30px;
  height: 30px;
  margin: 0 20px;

  @include breakpoint(xs) {
    width: 15px;
    height: 15px;
  }

  @include breakpoint(sm) {
    width: 15px;
    height: 15px;
  }

  @include breakpoint(md) {
    width: 18px;
    height: 18px;
  }
}

.explore-subheader {
  margin-top: 13px;
}

.model-fade-leave-active {
  transition: opacity 0.5s;
}

.model-fade-leave-active {
  position: absolute;
  top: 0;
  left: 0;
  display: block;
  filter: grayscale(1%);
}

.model-fade-enter, .model-fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.inactivebuttons {
  opacity: 0;
}

.video-container {
  width: 100%;
  display: block;
  margin: 0 auto;
  position: relative;

  video {
    width: 100%;
  }
  .play-icon-container {
    position: absolute;
    left: 50%;
    top: 50%;
    width: 10%;
    transform: translate(-50%, -50%);
    img {
      width: 100%;
    }
  }
}

.pathways-mobile {
  display: none;

  @include breakpoint(sm) {
    display: flex;
    align-items: center;
    flex-direction: column;

    .ms-container {
      width: 244px;
      height: 137px;
      display: flex;
      align-items: center;
      justify-content: center;
      position: relative;
      margin-bottom: 7px;

      img {
        width: 100%;
        height: auto;
        position: absolute;
        top: 0;
        left: 0;
      }

      button {
        font-size: rem(12px);
        color: $white;
        border: 2px solid $white;
        background-color: $blue;
        padding: rem(15px) rem(10px);
        width: 150px;
        position: relative;
        z-index: 5;

        @include breakpoint(md) {
          font-size: rem(10px);
        }
      }
    }
  }

  // @include breakpoint(md) {
  //   display: flex;
  //   align-items: center;
  //   flex-direction: column;

  //   .ms-container {
  //     width: 244px;
  //     height: 137px;
  //     display: flex;
  //     align-items: center;
  //     justify-content: center;
  //     position: relative;
  //     margin-bottom: 7px;

  //     img {
  //       width: 100%;
  //       height: auto;
  //       position: absolute;
  //       top: 0;
  //       left: 0;
  //     }

  //     button {
  //       font-size: rem(12px);
  //       color: $white;
  //       border: 2px solid $white;
  //       background-color: $blue;
  //       padding: rem(15px) rem(10px);
  //       width: 150px;
  //       position: relative;
  //       z-index: 5;
  //     }
  //   }
  // }
}

.hide-xs {
  display: none;
}

.pathway1,
.pathway2,
.pathway3 {
  img {
    width: 100%;

    @include breakpoint(md) {
      position: relative;
      width: 545px;
      left: 50%;
      transform: translateX(-50%);
    }
  }
}
</style>
